// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --text-color-primary: #ef8200;
  font-size: 16px;
}

/* Responsive root font size based on screen width */

@media (max-width: 768px) {
  :root {
    font-size: 13px;
  }
}

@media (min-width: 769px) and (max-width: 1200px) {
  :root {
    font-size: 14px;
  }
}

@media (min-width: 1201px) and (max-width: 1920px) {
  :root {
    font-size: 16px;
  }
}

@media (min-width: 1921px) {
  :root {
    font-size: 18px;
  }
}

body {
  width: 100vw;
  height: 100vh;
  background: white;
}

.ant-table-cell {
  line-height: 1.25 !important;
  padding: 0.5rem 1rem !important;
  overflow-x: hidden;
}

.ant-table-row .ant-table-cell {
  border-top: 1px solid #00000030;
}

.ant-input-outlined[disabled] {
  color: rgb(0,0,0,0.5) !important;
}

.mt-3 {
  margin-top: 0.75rem;
}

.d-flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.overflow-auto {
  overflow: auto;
}

.flex-wrap {
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.me-3 {
  margin-right: 0.75rem;
}

.space-between {
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.align-items-center {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.report-modal {}

.md-icon {
  font-size: 1rem;
}

.pointer {
  cursor: pointer;
}

.ms-3 {
  margin-left: 0.5rem;
}

.ms-auto {
  margin-left: auto;
}

.text-right {
  text-align: right;
}

.ant-btn-primary {
  /* background-color: #fca428 !important; */
  background-color: #7d48b0;
}

.bold-font {
  font-weight: bold;
}

.bold-font svg {
  -webkit-filter: contrast(3) brightness(1);
          filter: contrast(3) brightness(1);
}

.ant-card-bordered {
  border: 1px solid #b8b1b1f7;
  border-radius: 5px;
}

.ant-card-body {
  padding: 1rem !important;
}

.header-title {
  color: white;
  font-weight: bold;
}

.header-desc {
  color: gainsboro;
  font-size: small;
}

.bottom-study-item {
  position: absolute;
  top: 0
}

.prev-study-item {
  border: 1px solid white;
  margin-left: 0.5rem;
  position: relative;
  /* width: '100%'; */
  min-width: 224px;
}

.line-height1 {
  line-height: 1 !important;
}

.study-item-desc {
  line-height: 1 !important;
  height: auto !important;
  line-height: 1rem !important;
}

.h-100 {
  height: 100%;
}

.page-title {
  font-size: 2.25rem;
  color: #e98611;
  font-weight: 600;
}

.whitespace-normal {
  white-space: normal;
}

.fav-btn, .favorite-tool {
  /* border-left: 4px solid orange; */
  border: 2px solid #f4efe763;
  position: relative;
  margin-right: 4px;
}

.fav-btn::after, .favorite-tool::after {
  content: "★";
  position: absolute;
  top: -3px;
  right: -2px;
  /* background: #ff6b6b; */
  color: #ecc72b;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  font-size: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  z-index: 10;
  -webkit-box-shadow: 0 1px 3px rgba(0,0,0,0.3);
          box-shadow: 0 1px 3px rgba(0,0,0,0.3);
}

[role='switch'] {
  background: lightgray;
}

.switch-filter {
  border: 1px solid #bfbcbc;
  border-radius: 6px;
  width: 200px;
  height: 32px;
}

.col-pat-name {
  color: #1b2d47 !important;
  font-weight: bold;
}

.status-tag {
  font-weight: bold;
}

.float-label .ant-input-outlined {
  border-color: #bfbcbc !important;
}

.float-label .ant-select-selector {
  border-color: #bfbcbc !important;
}

.float-label .ant-picker-outlined {
  border-color: #bfbcbc !important;
}

.shared-viewer-body {
  height: 100vh;
  overflow: hidden;
}

.restricted-viewer {
  position: relative;
  height: 100vh;
  overflow: hidden;
}

.bg-red {
  /* background-color: rgb(255, 128, 0) !important; */
}

.loading-progress-bar {
  border: 8px solid #f3f3f3; /* Light grey border */
  border-top: 8px solid #3498db; /* Blue border for the spinning part */
  border-radius: 50%; /* Makes it a circle */
  width: 20px;
  height: 20px;
  -webkit-animation: spin 1s linear infinite;
          animation: spin 1s linear infinite; /* Animation: name, duration, timing, iteration */
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}

/* Animated dot logo styles */

.dot-animation {
  -webkit-animation: pulse 2s infinite;
          animation: pulse 2s infinite;
}

.dot-1 {
  -webkit-animation-delay: 0s;
          animation-delay: 0s;
}

.dot-2 {
  -webkit-animation-delay: 0.2s;
          animation-delay: 0.2s;
}

.dot-3 {
  -webkit-animation-delay: 0.4s;
          animation-delay: 0.4s;
}

.dot-4 {
  -webkit-animation-delay: 0.6s;
          animation-delay: 0.6s;
}

.dot-5 {
  -webkit-animation-delay: 0.8s;
          animation-delay: 0.8s;
}

.dot-6 {
  -webkit-animation-delay: 1.0s;
          animation-delay: 1.0s;
}

.dot-7 {
  -webkit-animation-delay: 1.2s;
          animation-delay: 1.2s;
}

.dot-8 {
  -webkit-animation-delay: 1.4s;
          animation-delay: 1.4s;
}

@-webkit-keyframes pulse {
  0%, 100% {
    opacity: 1;
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 0.5;
    -webkit-transform: scale(1.2);
            transform: scale(1.2);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 0.5;
    -webkit-transform: scale(1.2);
            transform: scale(1.2);
  }
}
`, "",{"version":3,"sources":["webpack://./index.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,oDAAoD;;AACpD;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA,eAAe;;AAEf;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yCAAiC;UAAjC,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAGA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EAEnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,6CAAqC;UAArC,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;EACjD,6BAA6B,EAAE,sCAAsC;EACrE,kBAAkB,EAAE,sBAAsB;EAC1C,WAAW;EACX,YAAY;EACZ,0CAAkC;UAAlC,kCAAkC,EAAE,iDAAiD;AACvF;;AAEA;EACE;IACE,+BAAuB;YAAvB,uBAAuB;EACzB;EACA;IACE,iCAAyB;YAAzB,yBAAyB;EAC3B;AACF;;AAPA;EACE;IACE,+BAAuB;YAAvB,uBAAuB;EACzB;EACA;IACE,iCAAyB;YAAzB,yBAAyB;EAC3B;AACF;;AAEA,6BAA6B;;AAC7B;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EACE,2BAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,2BAAmB;YAAnB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,6BAAqB;YAArB,qBAAqB;EACvB;AACF;;AATA;EACE;IACE,UAAU;IACV,2BAAmB;YAAnB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,6BAAqB;YAArB,qBAAqB;EACvB;AACF","sourcesContent":[":root {\r\n  --text-color-primary: #ef8200;\r\n  font-size: 16px;\r\n}\r\n\r\n/* Responsive root font size based on screen width */\r\n@media (max-width: 768px) {\r\n  :root {\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n@media (min-width: 769px) and (max-width: 1200px) {\r\n  :root {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1201px) and (max-width: 1920px) {\r\n  :root {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1921px) {\r\n  :root {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\nbody {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: white;\r\n}\r\n\r\n.ant-table-cell {\r\n  line-height: 1.25 !important;\r\n  padding: 0.5rem 1rem !important;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.ant-table-row .ant-table-cell {\r\n  border-top: 1px solid #00000030;\r\n}\r\n\r\n.ant-input-outlined[disabled] {\r\n  color: rgb(0,0,0,0.5) !important;\r\n}\r\n\r\n.mt-3 {\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.d-flex {\r\n  display: flex;\r\n}\r\n\r\n.overflow-auto {\r\n  overflow: auto;\r\n}\r\n\r\n.flex-wrap {\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.me-3 {\r\n  margin-right: 0.75rem;\r\n}\r\n\r\n.space-between {\r\n  justify-content: space-between;\r\n}\r\n\r\n.align-items-center {\r\n  align-items: center;\r\n}\r\n\r\n.report-modal {}\r\n\r\n.md-icon {\r\n  font-size: 1rem;\r\n}\r\n\r\n.pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.ms-3 {\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n.ms-auto {\r\n  margin-left: auto;\r\n}\r\n\r\n.text-right {\r\n  text-align: right;\r\n}\r\n\r\n.ant-btn-primary {\r\n  /* background-color: #fca428 !important; */\r\n  background-color: #7d48b0;\r\n}\r\n\r\n.bold-font {\r\n  font-weight: bold;\r\n}\r\n\r\n.bold-font svg {\r\n  filter: contrast(3) brightness(1);\r\n}\r\n\r\n.ant-card-bordered {\r\n  border: 1px solid #b8b1b1f7;\r\n  border-radius: 5px;\r\n}\r\n\r\n.ant-card-body {\r\n  padding: 1rem !important;\r\n}\r\n\r\n\r\n.header-title {\r\n  color: white;\r\n  font-weight: bold;\r\n}\r\n\r\n.header-desc {\r\n  color: gainsboro;\r\n  font-size: small;\r\n}\r\n\r\n.bottom-study-item {\r\n  position: absolute;\r\n  top: 0\r\n}\r\n\r\n.prev-study-item {\r\n  border: 1px solid white;\r\n  margin-left: 0.5rem;\r\n  position: relative;\r\n  /* width: '100%'; */\r\n  min-width: 190px;\r\n  min-width: 224px;\r\n}\r\n\r\n.line-height1 {\r\n  line-height: 1 !important;\r\n}\r\n\r\n.study-item-desc {\r\n  line-height: 1 !important;\r\n  height: auto !important;\r\n  line-height: 1rem !important;\r\n}\r\n\r\n.h-100 {\r\n  height: 100%;\r\n}\r\n\r\n.page-title {\r\n  font-size: 2.25rem;\r\n  color: #e98611;\r\n  font-weight: 600;\r\n}\r\n\r\n.whitespace-normal {\r\n  white-space: normal;\r\n}\r\n\r\n.fav-btn, .favorite-tool {\r\n  /* border-left: 4px solid orange; */\r\n  border: 2px solid #f4efe763;\r\n  position: relative;\r\n  margin-right: 4px;\r\n}\r\n\r\n.fav-btn::after, .favorite-tool::after {\r\n  content: \"★\";\r\n  position: absolute;\r\n  top: -3px;\r\n  right: -2px;\r\n  /* background: #ff6b6b; */\r\n  color: #ecc72b;\r\n  border-radius: 50%;\r\n  width: 16px;\r\n  height: 16px;\r\n  font-size: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 10;\r\n  box-shadow: 0 1px 3px rgba(0,0,0,0.3);\r\n}\r\n\r\n[role='switch'] {\r\n  background: lightgray;\r\n}\r\n\r\n.switch-filter {\r\n  border: 1px solid #bfbcbc;\r\n  border-radius: 6px;\r\n  width: 200px;\r\n  height: 32px;\r\n}\r\n\r\n.col-pat-name {\r\n  color: #1b2d47 !important;\r\n  font-weight: bold;\r\n}\r\n\r\n.status-tag {\r\n  font-weight: bold;\r\n}\r\n\r\n.float-label .ant-input-outlined {\r\n  border-color: #bfbcbc !important;\r\n}\r\n\r\n.float-label .ant-select-selector {\r\n  border-color: #bfbcbc !important;\r\n}\r\n\r\n.float-label .ant-picker-outlined {\r\n  border-color: #bfbcbc !important;\r\n}\r\n\r\n.shared-viewer-body {\r\n  height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.restricted-viewer {\r\n  position: relative;\r\n  height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.bg-red {\r\n  /* background-color: rgb(255, 128, 0) !important; */\r\n}\r\n\r\n.loading-progress-bar {\r\n  border: 8px solid #f3f3f3; /* Light grey border */\r\n  border-top: 8px solid #3498db; /* Blue border for the spinning part */\r\n  border-radius: 50%; /* Makes it a circle */\r\n  width: 20px;\r\n  height: 20px;\r\n  animation: spin 1s linear infinite; /* Animation: name, duration, timing, iteration */\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* Animated dot logo styles */\r\n.dot-animation {\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n.dot-1 {\r\n  animation-delay: 0s;\r\n}\r\n\r\n.dot-2 {\r\n  animation-delay: 0.2s;\r\n}\r\n\r\n.dot-3 {\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n.dot-4 {\r\n  animation-delay: 0.6s;\r\n}\r\n\r\n.dot-5 {\r\n  animation-delay: 0.8s;\r\n}\r\n\r\n.dot-6 {\r\n  animation-delay: 1.0s;\r\n}\r\n\r\n.dot-7 {\r\n  animation-delay: 1.2s;\r\n}\r\n\r\n.dot-8 {\r\n  animation-delay: 1.4s;\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    opacity: 0.5;\r\n    transform: scale(1.2);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
